<template>
  <div class="content surveryEr">
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>能耗管理</el-breadcrumb-item>
            <el-breadcrumb-item>能耗监测</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <div class="er-box">
      <div class="box-head">
        <span>月份：</span>
        <el-date-picker
          v-model="search.month"
          type="month"
          value-format="yyyy-MM"
          @change="doFilter"
          placeholder="选择月">
        </el-date-picker>
      </div>
      <div class="box-main">
        <div id="erBar"></div>
      </div>
    </div>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base.js'

export default {
  data() {
    return {
      // calendarData: [],
      // listData:[],//准备值
      // value: new Date(),
      groupId:'',
      // year:new Date().getFullYear(),
      search:{
        month:util.myTime.getCurMonth()
      },
      water:[],
      ele:[],
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.getData()
    // this.getEleData()
    var that = this
    // setTimeout(function(){
    //   that.setBar()
    // },1000)
    
  },
  methods: {
    // 搜索数据
    doFilter() {
      this.getData()
    },
    //判断增长或者减少
    getBilv(val1,val2){
      var result = 0
      if(parseInt(val1)>parseInt(val2)){
        result = -1
      }else if(parseInt(val1)<parseInt(val2)){
        result = 1
      }
      return result
    },
    getBilvVal(val1,val2){
      var result = 0
      if(parseInt(val1)==0 && parseInt(val2)>0){
        result = 100
      }else if(parseInt(val1)>parseInt(val2)){
        result = (((parseInt(val1)-parseInt(val2))/parseInt(val1))*100).toFixed(0)
      }else if(parseInt(val1)<parseInt(val2)){
        result = (((parseInt(val2)-parseInt(val1))/parseInt(val1))*100).toFixed(0)
      }
      return result
    },
    //获取数据
    getData(){
      var that = this
      this.listData = []
      myHttp.selectWaterByMonth({
        projectId:this.groupId,
        time:this.search.month,
        type:'1',  //水
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.monthWater||[]
          var water = []
          for(var i=0;i<list.length;i++){
            water.push(list[i].calculateUseOf)
          }
          that.water = water
        }
        that.getEleData()
      })
    },

    //获取电数据
    getEleData(){
      var that = this
      myHttp.selectWaterByMonth({
        projectId:this.groupId,
        time:this.search.month,
        type:'2',  //电
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.monthWater||[]
          var ele = []
          for(var i=0;i<list.length;i++){
            // var type = 0
            // var bilv = 0
            // if(i>0){
            //   type = that.getBilv(list[i-1].calculateUseOf,list[i].calculateUseOf)
            //   bilv = that.getBilvVal(list[i-1].calculateUseOf,list[i].calculateUseOf)
            // }
            // that.listData[i].ele =  list[i].calculateUseOf
            // that.listData[i].eleType =  type
            // that.listData[i].eleVal =  bilv
            // that.listData[i].eleAll = list[i].useOf
            ele.push(list[i].calculateUseOf)
          }
          that.ele = ele
        }
        setTimeout(function(){that.setBar()},100)
        
      })
    },

    //展示
    setBar(){
      var days = util.myTime.getMonthDay(this.search.month)
      var daysList = []
      for(var i=0;i<days;i++){
        daysList.push((i+1)+'日')
      }
      var option = {
        color: ['#ffc833','#748efc', '#61a0a8'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params) {
              var str = params[0].name+'<br/>'
              for(var i=0;i<params.length;i++){
                var tar = params[i]
                if(tar.seriesName=='用电量'){
                  str += tar.seriesName + ' : ' + tar.value +" KW <br/>"
                }else{
                  str += tar.seriesName + ' : ' + tar.value +" T <br/>"
                }
              }
              return str
            },
            textStyle:{
              align:'left'
            }
            
        },
        legend: {
            data: ['用电量', '用水量']
        },
        grid: {
            left: '3%',
            right:'4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: daysList
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [
            {
                name: '用电量',
                type: 'bar',
                data: this.ele
            },
            {
                name: '用水量',
                type: 'bar',
                data: this.water
            },
        ]
      }
      var myChart2 = this.$echarts.init(document.getElementById('erBar'))
      myChart2.setOption(option)
    },

    showFun(obj){
      
    },

  }
}
</script>
<style>
  @import '../../assets/css/common.css';
  .surveryEr .el-calendar-table .el-calendar-day{
    height: 160px;
  }
</style>
<style scoped>
  .content >>> .el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }
  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }
  .search-section {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 20px 35px 20px -12px;
    height: 40px;
    justify-content: space-between;
  }
  .is-selected {
    color: #000;
    /* margin: 10px 40px; */
    padding: 20px 10px 0;
    text-align: left;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .title{
    display: flex;
    width: 200px;
      position: absolute;
      top: 14px;
      /* left: 0px; */
      right: 250px;
      justify-content: space-between;
      align-items: center;
  }

  .er-box{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }
  .box-head{
    width: 100%;
    height: 6vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .box-main{
    width: 100%;
    height: calc( 100% - 6vh );
    position: relative;
    padding: 1vh;
  }
  #erBar{
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>